import React, { memo } from "react";
import { Button, Card, Col, Input, Row } from "antd";
import { FaTimes } from "react-icons/fa";

const { TextArea } = Input;

/**
 * Inline Form Component for adding Important Information
 *
 * @param {{
 *   showForm: boolean,
 *   formData: { status: string, detail: string },
 *   isSubmitting: boolean,
 *   onChangeStatus: (val: string) => void,
 *   onChangeDetail: (val: string) => void,
 *   onCancel: () => void,
 *   onSave: () => void,
 * }} props
 */
const ImportantInfoForm = ({
  showForm,
  formData,
  isSubmitting,
  onChangeStatus,
  onChangeDetail,
  onCancel,
  onSave,
}) => {
  if (!showForm) return null;

  return (
    <Card
      size="small"
      className="mb-3"
      style={{
        border: "1px solid #bae0ff",
        borderRadius: "8px",
        background: "#f0f9ff",
      }}
      bodyStyle={{ padding: "16px 20px" }}
    >
      <div
        className="d-flex justify-content-between align-items-center"
        style={{
          borderLeft: "4px solid var(--primary, #00a99d)",
          paddingLeft: "10px",
          marginBottom: "14px",
        }}
      >
        <span style={{ fontSize: "14px", fontWeight: "bold", color: "var(--primary, #00a99d)" }}>
          เพิ่มข้อมูลสำคัญ
        </span>
        <span
          onClick={onCancel}
          style={{ cursor: "pointer", color: "#8c8c8c", fontSize: "14px", lineHeight: 1 }}
          title="ปิด"
        >
          <FaTimes />
        </span>
      </div>

      <Row gutter={[16, 0]} className="mb-3" align="middle">
        <Col span={24}>
          <div style={{ fontSize: "11px", color: "#4b5563", fontWeight: "600", marginBottom: "5px" }}>
            สถานะ Case/สำคัญ <span style={{ color: "#ef4444" }}>*</span>
          </div>
          <Input
            value={formData.status}
            onChange={(e) => onChangeStatus(e.target.value)}
            placeholder="กรอกสถานะ หรือหัวข้อ Case/สำคัญ เช่น สำคัญ / แจ้งเตือนลูกค้า"
            style={{ borderRadius: "6px" }}
          />
        </Col>
      </Row>

      <Row gutter={[16, 0]} className="mb-3">
        <Col span={24}>
          <div style={{ fontSize: "11px", color: "#4b5563", fontWeight: "600", marginBottom: "5px" }}>
            ข้อมูล Case/สำคัญ <span style={{ color: "#ef4444" }}>*</span>
          </div>
          <TextArea
            value={formData.detail}
            onChange={(e) => onChangeDetail(e.target.value)}
            placeholder="กรอกรายละเอียดข้อมูลสำคัญ เช่น ลูกค้ามีอาการแพ้สินค้า / ลูกค้าขอยกเลิกสมาชิก"
            rows={2}
            style={{ borderRadius: "6px" }}
          />
        </Col>
      </Row>

      <div className="d-flex justify-content-end" style={{ gap: "8px" }}>
        <Button onClick={onCancel} disabled={isSubmitting}>
          ยกเลิก
        </Button>
        <Button type="primary" onClick={onSave} loading={isSubmitting}>
          บันทึก
        </Button>
      </div>
    </Card>
  );
};

export default memo(ImportantInfoForm);
